import RepoStats from "./RepoStats";

export default RepoStats;
